$(window).scroll(function () {
    if ($(window).scrollTop() >= 20) {
        $('body').addClass('fixed-header');
    }
    else {
        $('body').removeClass('fixed-header');
    }
});

$(document).ready(function () {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    $("#menu-toggle").click(function () {
        $("body").toggleClass("open");
    });

    $("[data-search-box-toggle]").click(function() {
        $("[data-search-box-open]").slideToggle(200);
        $("[data-search-box-toggle]").toggleClass("open");
        $("[data-search-box-open-input]").focus();
    });

    if ($("body").hasClass("page-type-search-page") && !isMobile) {
        $("[data-search-box-open]").slideToggle(0);
        $("[data-search-box-toggle]").toggleClass("open");
    }

    if (navigator.userAgent.indexOf('Edge') !== -1 && !isMobile) {
        $("[data-search-box-open-input]").removeAttr("placeholder"); // Removes the placeholder attribute when on Edge and not mobile, this is done to right align the input cursor, which is otherwise not possible in Edge with a placeholder active.
    }

    function setContentHeaderHeight() {
        $(".contentheader-rich").css('min-height', $(".contentheader-rich-body").outerHeight() + 50 + 'px');
    }

    if ($(".contentheader-rich-body").length != 0) {
        if ($(window).width() < 991 && $(".contentheader-rich-body").outerHeight() > 400) {
            setContentHeaderHeight();
        } else if ($(window).width() > 992 && $(window).width() < 1199 && $(".contentheader-rich-body").outerHeight() > 650) {
            setContentHeaderHeight();
        } else if ($(window).width() > 1200 && $(".contentheader-rich-body").outerHeight() > 650) {
            setContentHeaderHeight();
        }
    }
});